// @flow
import React, { useContext, useState, useEffect } from 'react';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { Box } from 'grommet';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import UpperContainer from 'esm-web-pro/components/layout/sidePanel/UpperContainer';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import { QuickViewContext } from 'esm-web-pro/containers/tables/columns/QuickViewComponent';
import { bindActionCreators } from 'redux';
import { closePanel as closePanelAction } from 'esm-web-pro/redux/side-panel';
import { connect } from 'react-redux';
import ButtonContainer from 'esm-web-pro/components/layout/sidePanel/ButtonContainer';
import BottomContainer from 'esm-web-pro/components/layout/sidePanel/BottomContainer';
import WallPointIcon from 'esm-web-pro/components/layout/sidePanel/icons/WallPointIcon';
import ShaftIcon from 'esm-web-pro/components/layout/sidePanel/icons/ShaftIcon';
import PillarIcon from 'esm-web-pro/components/layout/sidePanel/icons/PillarIcon';
import PoPIcon from 'esm-web-pro/components/layout/sidePanel/icons/PoPIcon';
import ForkIcon from 'esm-web-pro/components/layout/sidePanel/icons/Fork';
import LineCutIcon from 'esm-web-pro/components/layout/sidePanel/icons/LineCutIcon';
import CabinetIcon from 'esm-web-pro/components/layout/sidePanel/icons/CabinetIcon';
import GisLineIcon from 'esm-web-pro/components/layout/sidePanel/icons/GisLineIcon';
import MapObjectsActions from 'esm-web-pro/containers/pages/projects/mapobjects/MapObjectsActions';
import points11Messages from 'esm-web-pro/messages/points11Messages';

const icons = {
    wallpoint: <WallPointIcon />,
    shaft: <ShaftIcon />,
    pillar: <PillarIcon />,
    pop: <PoPIcon />,
    fork: <ForkIcon />,
    linecut: <LineCutIcon />,
    cabinet: <CabinetIcon />,
    LineString: <GisLineIcon />,
};

type Props = {
    editorKey: String,
    resourceName: String,
    excludeFields: Array,
    permissions: Array,
    panelId: String,
    attributes: Function,
    resourceArguments: Array,
    object: Object,
    reload: Function,
    closePanel: (key: string, skipSensitivity: boolean) => {key: string},
    getObjectType: Function,
    intl: IntlShape,
};

const MapObjectsSidePanel = (props: Props) => {
    const {
        editorKey, panelId, attributes, getObjectType,
        resourceArguments, object, reload, closePanel, resourceName, excludeFields, permissions,
        intl: { formatMessage },
    } = props;

    const [titleLabel, setTitleLabel] = useState('');
    const [icon, setIcon] = useState('');
    const [type, setType] = useState('');
    const [sequence, setSequence] = useState('');
    const [ref, setRef] = useState('');

    const isQuickview = useContext(QuickViewContext);

    useEffect(() => {
        setType(getObjectType(object));
    }, [object, getObjectType]);

    useEffect(() => {
        if (type) {
            setIcon(icons[type]);
            if (type === 'LineString') {
                setTitleLabel(<FormattedMessage id="map-objects-gis-line" defaultMessage="Line" />);
                setRef(object.ref);
            } else {
                setTitleLabel(`${formatMessage(points11Messages[type])}`);
                setSequence(object.gis_point.sequence);
            }
        }
    }, [type]);

    return (
        <SidePane
            id={panelId}
            openInitially
            closeAllOpened
            continuity
            title={ref || sequence}
            titleLabel={titleLabel}
            titleIcon={icon}
            actions={isQuickview ? <ButtonContainer handleClick={() => closePanel(panelId, true)} /> : null}
        >
            <Box height="100%" justify="between">
                <Box flex>
                    <HorizontalLine color="grey" />
                    <UpperContainer>
                        {attributes(object)}
                        <Box direction="row">
                            <MapObjectsActions
                                resourceArguments={resourceArguments}
                                mapObject={object}
                                reload={reload}
                                editorKey={editorKey}
                                resourceName={resourceName}
                                excludeFields={excludeFields}
                                permissions={permissions}
                                getObjectType={getObjectType}
                            />
                        </Box>
                    </UpperContainer>
                    <HorizontalLine color="grey" />
                    <BottomContainer>
                        <Box pad={{ bottom: '20px' }} height={{ min: '100%' }} />
                    </BottomContainer>
                </Box>
            </Box>
        </SidePane>
    );
};

const mapDispatchToProps = (dispatch) => (
    bindActionCreators({ closePanel: closePanelAction }, dispatch)
);

export default injectIntl(connect(null, mapDispatchToProps)(MapObjectsSidePanel));
